import { Theme } from '@mui/material/styles';
import { FormContainer } from 'react-hook-form-mui';
import { makeStyles } from 'tss-react/mui';
import { useUserUpdatePhoneSettings } from '../../../sic-lib/api/hooks/useUser';
import { EditUserTwilioPhoneData } from '../../../sic-lib/types/EditUserTwilioPhoneData';
import { PhoneSettingsFormControls } from './PhoneSettingsFormControls';

type Props = {
    phoneSettings: EditUserTwilioPhoneData;
};

export function PhoneSettingsForm({ phoneSettings }: Props) {
    const { classes } = useStyles();

    const {
        mutate: updateSettings,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useUserUpdatePhoneSettings();

    const handleSuccess = (data?: EditUserTwilioPhoneData) => {
        console.log('handleSuccess', data);
        if (data) {
            updateSettings(data);
        }
    };
    return (
        <FormContainer<EditUserTwilioPhoneData>
            onSuccess={handleSuccess}
            defaultValues={phoneSettings}
            mode="all"
        >
            <PhoneSettingsFormControls
                phoneSettings={phoneSettings}
                isLoading={isLoading}
                isError={isError}
                isSuccess={isSuccess}
                error={error}
            />
        </FormContainer>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
